import { Button, useToast, Center, Heading, VStack } from "@chakra-ui/react";
import { AdminCouponsEndpoints, fetcher } from "@olagg/api-hooks";
import OlaggFormInput from "../../../../components/Forms/OlaggFormInput";
import { useEffect, useState } from "react";
import OlaggForm from "../../../../components/Forms/OlaggForm";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup"
import { useParams } from "react-router-dom";
import { ROUTES } from "../../../../consts/routes";

const schema = yup.object().shape({
    limit: yup.number().min(0).required(),
    percentage: yup.number().min(0).max(100).required(),
    code: yup.string().required(),
    dueDate: yup.date().nullable().optional(),
    maxUses: yup.number().min(1).required(),
})

const PercentagePromoCoupon = () => {
    const { id } = useParams()
    const [coupon, setCoupon] = useState<any>(undefined);
    const toast = useToast();

    const useFormMethods = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: coupon
    })

    const onSubmit = (data: any) => {
        let submitFetch = AdminCouponsEndpoints.createPromotional(data)
        if (id) submitFetch = AdminCouponsEndpoints.updatePromotional({ id: id, ...data })
        fetcher(submitFetch)
            .then(() => {
                toast({
                    title: `Cupon generado`,
                    status: 'success',
                    position: 'bottom-right',
                    duration: 2000,
                    isClosable: false
                });
                window.location.href = `${ROUTES.MARKETPLACE.all}#cupones`;
            }).catch((error) => {
                toast({
                    title: `Error generando cupon`,
                    status: 'error',
                    position: 'bottom-right',
                    description: error.message,
                    duration: 2000,
                    isClosable: false
                });
            });
    }
    useEffect(() => {
        if (id) {
            fetcher(AdminCouponsEndpoints.showPromotional(id))
                .then((response) => {
                    setCoupon(response.promotionalCoupon);
                    useFormMethods.reset(response.promotionalCoupon);
                    console.log(response);
                    
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, [id])

    const currentUses = !id ? false : `(Usados: ${coupon?.currentUses})`

    if (id && !coupon)
        return <>Cargando...</>

    return (
        <Center w={'full'} pb={4}>
            <VStack color={'white'}>
                <Heading my={2}>
                    Cupón de porcentaje Promo
                </Heading>
                <OlaggForm
                    useFormMethods={useFormMethods}
                    onSubmit={onSubmit}
                >

                    <OlaggFormInput
                        label="Ingresa el código del cupón"
                        controlName='code'
                        required={true}
                    />

                    <OlaggFormInput
                        label="Ingresa el porcentaje de descuento del cupon (%)"
                        controlName='percentage'
                        required={true}
                    />

                    <OlaggFormInput
                        label="Monto maximo que se puede descontar del precio"
                        controlName='limit'
                        required={true}
                    />

                    <OlaggFormInput
                        label={`Cantidad máxima de uso del cupón ${currentUses}`}
                        controlName='maxUses'
                        required={true}
                    />

                    <OlaggFormInput
                        label='Fecha de vencimiento del cupon'
                        controlName='dueDate'
                        inputType='date'
                        description={`Zona horaria: UTC`}
                        datePickerProps={{ backgroundColor: 'white' }}
                        required={false}
                        
                    />

                    <Button
                        p={'0 10px'}
                        w="full"
                        variant="filledGradient"
                        fontSize="16px"
                        fontWeight="600"
                        cursor={'pointer'}
                        type='submit'
                    >
                        Generar
                    </Button>
                </OlaggForm>
            </VStack>
        </Center>
    )
}

export default PercentagePromoCoupon;